export default "__VITE_ASSET__CbM31yBX__"